/**
 * Per-ayah recitations from the everyayah.com CDN — the same reciters and
 * files the iOS app plays (QuranAudioStore.swift).
 */
export const RECITERS = [
  { id: 'alafasy', name: 'Mishary Rashid Alafasy', folder: 'Alafasy_128kbps' },
  { id: 'husary', name: 'Mahmoud Khalil Al-Husary', folder: 'Husary_128kbps' },
  { id: 'minshawi', name: 'Mohamed Siddiq Al-Minshawi', folder: 'Minshawy_Murattal_128kbps' },
  { id: 'sudais', name: 'Abdurrahman As-Sudais', folder: 'Abdurrahmaan_As-Sudais_192kbps' },
  { id: 'shuraim', name: 'Saud Ash-Shuraim', folder: 'Saood_ash-Shuraym_128kbps' },
  { id: 'ghamdi', name: 'Saad Al-Ghamdi', folder: 'Ghamadi_40kbps' },
];

export const DEFAULT_RECITER = RECITERS[0];

export const findReciter = (id) => RECITERS.find((r) => r.id === id) ?? DEFAULT_RECITER;

const pad3 = (n) => String(n).padStart(3, '0');

export const ayahAudioUrl = (reciter, surah, ayah) =>
  `https://everyayah.com/data/${reciter.folder}/${pad3(surah)}${pad3(ayah)}.mp3`;

export const PLAYBACK_RATES = [0.75, 1, 1.25, 1.5];
